export const parseQuestions = (value: string | undefined): any => {
  if (value === undefined || !value || value.length === 0) {
    return [{ question: '', choices: [''] }];
  }

  try {
    const questions = JSON.parse(value);
    questions.forEach((question: any) => {
      if (Array.isArray(question.choices)) {
        if (!Array.isArray(question.answer)) {
          question.answer = new Array(question.choices.length).fill(false);
        }
      }
    });
    return questions;
  } catch (error) {
    console.error(value);
    console.error('Error parsing JSON:', error);
    return [{ question: '', choices: [''] }];
  }
};
